import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const LegalCasesSettingsState = {
  closingReasons: [],
  closingReasonsLoading: false,
}

export const LegalCasesSettingsActions = {
  fetchClosingReasons: async ({ commit }) => {
    commit('setClosingReasonsLoading', true)

    return axiosRequest.get('/legal_cases/closing_reasons').
      then(({ data }) => {
        commit('setClosingReasons', data || [])
      }).
      catch(handleError).
      finally(_ => commit('setClosingReasonsLoading', false))
  },
}

export const LegalCasesSettingsMutations = {
  setClosingReasons: (state, data) => { state.closingReasons = [...data, { id: '-1', label: 'Other' }] },
  setClosingReasonsLoading: (state, value) => { state.closingReasonsLoading = value },
}

export const LegalCasesSettingsGetters = {
  closingReasons: state => state.closingReasons,
  closingReasonsLoading: state => state.closingReasonsLoading,
}
